import { BookOpenCheckIcon, ClipboardCheckIcon, FolderOpenIcon, MapIcon, TargetIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Hydrology Activities & Classroom Challenges',
    description:
      '150 ready-to-use activity ideas covering the hydrological cycle, precipitation, watersheds, groundwater, water quality, floods, droughts, and water resources. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'The Complete Hydrology Assessment Bank',
    description:
      'Diagnostic assessments, progress activities, multiple-choice questions, true/false exercises, short-answer prompts, extended-response questions, data-interpretation activities, case-based assessments, rubrics, and scoring criteria.',
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Real-World Hydrology Case Studies',
    description:
      'One hundred written educational cases covering water scarcity, urban flooding, river-basin management, groundwater depletion, aquifer contamination, drought response, wetland degradation, dam management, transboundary conflicts, and climate-related changes. Each includes context, analysis questions, and teaching applications.',
    benefit: 'Your students learn by analyzing authentic hydrological challenges.',
    value: 'USD 14',
    icon: MapIcon,
  },
  {
    number: '04',
    title: '50 Project-Based Learning Proposals for Hydrology',
    description:
      '50 fully explained project ideas connecting hydrology with environmental science, geography, climate science, engineering, urban development, and disaster-risk reduction. Each includes driving questions, objectives, development stages, expected outcomes, and assessment criteria.',
    benefit: 'Your students finish the year with real watershed and water-resource projects.',
    value: 'USD 14',
    icon: TargetIcon,
  },
  {
    number: '05',
    title: 'Hydrology Concepts, Questions & Explanations',
    description:
      'Teacher-focused reference containing essential hydrology terminology, clear process explanations, frequently asked questions, common student misconceptions, concept comparisons, discussion prompts, connections to real situations, and review questions for each major hydrology topic.',
    benefit: 'Project it in class and your students instantly understand complex hydrological concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
